﻿import { RoutingFlags } from '@constants/routingFlags';

import { RouteDefT } from '../../routes';

export const FEATURE_FLAG_ROUTE = '/feature-flags';
export const FEATURE_FLAG_EXPLORER_ROUTE = '/feature-flag-explorer';
export const FEATURE_FLAG_NEW_ROUTE = '/feature-flags/new';

export const FeatureFlagRoute: RouteDefT = {
  path: FEATURE_FLAG_ROUTE,
  load: () => import('./FeatureFlagManager'),
  protected: true,
  routingFlag: RoutingFlags.FeatureFlagManagement,
};

export const FeatureFlagNewRoute: RouteDefT = {
  path: FEATURE_FLAG_NEW_ROUTE,
  load: () => import('./featureFlagPortal/FeatureFlagPortalPage'),
  protected: true,
  routingFlag: RoutingFlags.FeatureFlagManagement,
};

export const FeatureFlagExplorerRoute = {
  path: FEATURE_FLAG_EXPLORER_ROUTE,
  load: () => import('./featureFlagExplorer/FeatureFlagExplorer'),
  protected: true,
  routingFlag: RoutingFlags.FeatureFlagManagement,
};
